// extracted by mini-css-extract-plugin
module.exports = {"colorsSelector":"ColorsSelector_colorsSelector__roWxg","list":"ColorsSelector_list__mZ_gc","label":"ColorsSelector_label__52wJk"};